import React, { useRef, useEffect, useState } from "react";
import "./IntroParallaxSection.css"; 

const slides = [
  {
    bg: require('../Images/BGServices2.jpg'),
    heading: 'Pioneering Smart Illumination',
    description: 'We blend innovation with reliability, offering custom architectural lighting, market-leading products, and unparalleled after-sales support. Experience the future of efficient and intelligent illumination.',
    cta: 'Discover Our Solutions',
    ctaLink: '#about'
  }
];

const IntroParallaxSection = () => {
  const contentRefs = useRef(slides.map(() => React.createRef()));
  const [inViews, setInViews] = useState(Array(slides.length).fill(false));

  useEffect(() => {
    // ... no changes to the useEffect hook ...
    const observers = [];
    contentRefs.current.forEach((ref, idx) => {
      if (!ref.current) return;
      const observer = new window.IntersectionObserver(
        ([entry]) => {
          setInViews(prev => {
            const updated = [...prev];
            updated[idx] = entry.isIntersecting;
            return updated;
          });
        },
        { threshold: 0.3 }
      );
      observer.observe(ref.current);
      observers.push(observer);
    });
    return () => observers.forEach(observer => observer.disconnect());
  }, []);

  return (
    // NEW: Added a wrapper to act as a frame for the border-radius
    <div className="parallax-frame-container">
      <div className="elementor-parallax-intro">
        {slides.map((slide, idx) => (
          <section
            key={idx}
            className="elementor-parallax-slide"
            style={{
              backgroundImage: `url(${slide.bg})`,
            }}
          >
            <div className="elementor-parallax-overlay" />
            <div
              ref={contentRefs.current[idx]}
              className={`elementor-parallax-content${inViews[idx] ? ' in-view' : ''}`}
            >
              <h2 className="elementor-parallax-heading">{slide.heading}</h2>
              <p style={{ textAlign: "justify" }} className="elementor-parallax-description">{slide.description}</p>
              {/* <a href={slide.ctaLink} className="elementor-parallax-cta">{slide.cta}</a> */}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default IntroParallaxSection;